import { type ReactNode, useState } from 'react';
import { Botao } from './ui';

/**
 * Folha de compartilhar — fallback quando `navigator.share` não existe ou falha
 * (UX §5.3, DESIGN-FOUNDATION §6.3). Nível 3: `--superficie-alta` + `--r-2` +
 * `--sombra-1`. Animação 2/3 (§4.1): fade + subida de 8px.
 *
 * A mensagem é **editável** antes de enviar. Benefício do amigo primeiro (já
 * está no texto). "Copiar só o código" para quem vai ditar por telefone.
 */
export function FolhaCompartilhar({
  codigo,
  mensagemInicial,
  aoFechar,
}: {
  codigo: string;
  mensagemInicial: string;
  aoFechar: () => void;
}): ReactNode {
  const [mensagem, setMensagem] = useState(mensagemInicial);
  const [copiado, setCopiado] = useState<'mensagem' | 'codigo' | null>(null);

  const copiar = async (texto: string, qual: 'mensagem' | 'codigo'): Promise<void> => {
    try {
      await navigator.clipboard.writeText(texto);
      setCopiado(qual);
      window.setTimeout(() => setCopiado(null), 1600);
    } catch {
      /* clipboard indisponível */
    }
  };

  const abrirWa = (): void => {
    window.open(`https://wa.me/?text=${encodeURIComponent(mensagem)}`, '_blank', 'noopener');
  };

  return (
    <div className="anim-folha-entra rounded-2 bg-superficie-alta p-5 shadow-[var(--sombra-1)]">
      <p className="tipo-corpo-forte text-tinta-forte">Enviar para um amigo</p>
      <p className="mt-1 tipo-nota text-tinta-2">
        A mensagem já vai escrita — é só escolher para quem.
      </p>

      <label className="mt-3 block">
        <span className="sr-only">Mensagem de indicação</span>
        <textarea
          value={mensagem}
          onChange={(e) => setMensagem(e.target.value)}
          rows={6}
          className="tipo-nota w-full rounded-1 border border-linha-forte bg-superficie px-3 py-2 text-tinta"
        />
      </label>

      <div className="mt-3 flex flex-col gap-2">
        <Botao variante="primario" onClick={abrirWa}>
          Abrir no WhatsApp
        </Botao>
        <Botao variante="secundario" onClick={() => void copiar(mensagem, 'mensagem')}>
          {copiado === 'mensagem' ? 'Mensagem copiada' : 'Copiar mensagem'}
        </Botao>
        <Botao variante="secundario" onClick={() => void copiar(codigo, 'codigo')}>
          {copiado === 'codigo' ? 'Código copiado' : 'Copiar só o código'}
        </Botao>
        <Botao variante="terciario" onClick={aoFechar}>
          Fechar
        </Botao>
      </div>
    </div>
  );
}
